export const blockedUsersKeys = {
  all: ['blocked-users'],
  list: (params: any) => ['blocked-users', 'list', params],
  detail: (id: any) => ['blocked-users', 'detail', id],
};
